import { EndorsementsCountBadge } from '@pages/User/components';
import type { ColumnHelper } from '@tanstack/react-table';
import { get } from 'lodash-es';

enum ShowEndorsementsOptions {
  Show = 'SHOW',
  Hide = 'HIDE',
}

const endorsementsFilterOptions = [
  { value: ShowEndorsementsOptions.Show, label: 'With endorsements' },
  { value: ShowEndorsementsOptions.Hide, label: 'Without endorsements' },
];

export const endorsementsAccessor = <T extends { endorsementsCount?: number }>(columnHelper: ColumnHelper<T>) =>
  columnHelper.accessor((entity) => entity.endorsementsCount, {
    id: 'endorsementsCount',
    header: 'Endorsements',
    cell: (cellContext) => <EndorsementsCountBadge count={cellContext.getValue()} label="Endorsement" />,
    sortUndefined: 'last',
    size: 164,
    meta: {
      filter: {
        label: 'Endorsements',
        placeholder: 'Show endorsements',
        isSingleSelection: true,
        optionsMapping: endorsementsFilterOptions,
        order: Number.MAX_SAFE_INTEGER,
      },
      headingCellClassName: '2xl:w-24',
    },
    filterFn: (row, _, selected) => {
      const endorsementsCount = get(row.original, 'endorsementsCount', 0);
      if (selected === ShowEndorsementsOptions.Show) {
        return endorsementsCount >= 1;
      }

      if (selected === ShowEndorsementsOptions.Hide) {
        return endorsementsCount < 1;
      }

      return true;
    },
  });
